import React from 'react';
import ReactDOM from 'react-dom';

// Redux
import { Provider } from 'react-redux';
import store from '@redux/store';

// App
import App from './App';

// Styling
import '@styles/default.less';
import 'font-awesome/css/font-awesome.min.css';

const app = (
  <Provider store={store}>
    <App />
  </Provider>
);

ReactDOM.render(app, document.getElementById('root'));
